
export const getDeviceInfo = () => {
  // TODO complete this function, replace "MOCKS"s
  return {
    ip_address: "await getLocalIP()",
    device_type: "undefined",
    operating_system: window.navigator.platform,
    browser: {
      name: window.navigator.userAgent,
      version: window.navigator.appVersion,
    },
    screen_resolution: window.screen.width + "x" + window.screen.height,
    locale: window.navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    app_version: "undefined",
    model: "undefined",
    manufacturer: "undefined",
  };
};

